import { Fragment, useCallback, useMemo, useState } from 'react';

import { getVendorWordPlural } from '@zola-helpers/client/dist/es/marketplace/vendorWords';
import { SearchIcon as SearchIconV2 } from '@zola/zola-ui/src/components/SvgIconsV3/Search';
import { createKeyClickHandler } from '@zola/zola-ui/src/util/handleKeys';

import capitalize from 'lodash/capitalize';

import { isSearchLocation } from '~/util/searchUtils';

import { ChangeSearchModal } from './ChangeSearchModal';
import { useSRPSearchBarContext } from './SRPSearchBarContext';

import styles from './mobileSearchDropdownsPlaceholder.module.less';

export const MobileSearchDropdownsPlaceholder = () => {
  const { selectedLocation, nextTaxonomySearch } = useSRPSearchBarContext();

  const value = useMemo(() => {
    if (isSearchLocation(selectedLocation)) {
      return `${
        nextTaxonomySearch ? capitalize(getVendorWordPlural(nextTaxonomySearch.key)) : 'Vendors'
      } in ${selectedLocation?.label}`;
    }
    if (nextTaxonomySearch) {
      return capitalize(getVendorWordPlural(nextTaxonomySearch.key));
    }
    return 'Search Vendors on Zola';
  }, [selectedLocation, nextTaxonomySearch]);

  const [isOpen, setIsOpen] = useState(false);

  const onKeyUp = useCallback(
    createKeyClickHandler(() => setIsOpen(true)),
    [setIsOpen]
  );

  return (
    <Fragment>
      <ChangeSearchModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className={styles.mobileSearchDropdownsPlaceholderContainer}>
        <div
          role="button"
          className={styles.mobileDropdownPlaceholder}
          onClick={() => setIsOpen(true)}
          onKeyUp={onKeyUp}
          tabIndex={0}
          aria-label="Change your search"
        >
          <span>{value}</span>
          <SearchIconV2 height={20} width={20} showTitle={false} />
        </div>
      </div>
    </Fragment>
  );
};
